<template>
  <div class="login">
    <el-form
      size="small"
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      v-show="bancode === 1"
    >
      <img
        class="logo"
        src="../../../assets/door/tphdeng.png"
        alt=""
        style="height: 60px"
      />

      <el-form-item prop="userName">
        <el-input
          v-model="loginForm.userName"
          type="text"
          auto-complete="off"
          placeholder="请输入手机号码"
        >
          <i slot="prefix" class="el-icon-phone"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="请输入密码"
          @keyup.enter.native="handleLogin"
        >
          <i slot="prefix" class="el-icon-lock"></i>
        </el-input>
      </el-form-item>
      <el-checkbox
        v-model="loginForm.rememberMe"
        style="margin: 0px 0px 25px 0px"
        >记住密码</el-checkbox
      >
      <span class="zczh" @click="qiehaun(1)">注册账号</span>
      <el-form-item style="width: 100%">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
    <el-form
      size="small"
      ref="registerForm"
      :model="registerForm"
      :rules="registerRules"
      class="login-form"
      v-show="bancode === 2"
    >
      <h3 class="title">账号注册</h3>
      <el-form-item prop="userName">
        <el-input
          v-model="registerForm.userName"
          type="text"
          auto-complete="off"
          placeholder="手机号码注册"
        >
          <i slot="prefix" class="el-icon-phone"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="nickName">
        <el-input
          v-model="registerForm.nickName"
          type="text"
          auto-complete="off"
          placeholder="呢称"
        >
          <i slot="prefix" class="el-icon-user-solid"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="registerForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleRegister"
        >
          <i slot="prefix" class="el-icon-lock"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <el-input
          v-model="registerForm.confirmPassword"
          type="password"
          auto-complete="off"
          placeholder="确认密码"
          @keyup.enter.native="handleRegister"
        >
          <i slot="prefix" class="el-icon-lock"></i>
        </el-input>
      </el-form-item>

      <el-form-item style="width: 100%">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleRegister"
        >
          <span v-if="!loading">注 册</span>
          <span v-else>注 册 中...</span>
        </el-button>
        <span class="zczh" @click="qiehaun(2)">使用已有账户登录</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.registerForm.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      title: process.env.VUE_APP_TITLE,
      codeUrl: "",
      loginForm: {
        userName: "",
        password: "",
        rememberMe: false,
      },

      loginRules: {
        userName: [
          { required: true, trigger: "blur", message: "请输入您的手机号" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
      },
      loading: false,
      bancode: 1,
      registerForm: {
        userName: "",
        nickName: "",
        password: "",
        confirmPassword: "",
      },
      registerRules: {
        userName: [
          { required: true, trigger: "blur", message: "请输入您的手机号" },
          {
            min: 11,
            max: 11,
            message: "手机号长度必须为11位",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9]*$/,
            message: "只能输入数字、字母",
            trigger: "blur",
          },
        ],
        nickName: [
          { required: true, trigger: "blur", message: "请输入您的昵称" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          {
            min: 6,
            max: 20,
            message: "用户密码长度必须介于6-20之间",
            trigger: "blur",
          },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!?/@#\\$%^&*()-_=+|])(?=.{8,})/,
            message: "密码需包含大小写字母、数字和特殊字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的密码" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
      },
    };
  },

  mounted() {},
  methods: {
    qiehaun(val) {
      if (val === 1) {
        this.bancode = 2;
        this.reset();
      } else if (val === 2) {
        this.bancode = 1;
        this.reset();
      }
    },
    reset() {
      (this.loginForm = {
        userName: "",
        password: "",
        rememberMe: false,
      }),
        (this.registerForm = {
          userName: "",
          nickName: "",
          password: "",
          confirmPassword: "",
        });
    },

    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          axios({
            method: "POST",
            url: "https://ntgl.tlsyjxndc.com:35010/tanpuhui/login",
            // url: "http://10.166.16.8:35010/tanpuhui/login",
            data: this.loginForm,
          }).then((res) => {
            if (res.data.code == 200) {
              this.loading = false;
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.$router.push("/main"); // 直接使用路径
            } else if (res.data.code == 500) {
              this.loading = false;
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    handleRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          axios({
            method: "POST",
            url: "https://ntgl.tlsyjxndc.com:35010/tanpuhui/register",
            // url: "http://10.166.16.8:35010/tanpuhui/register",
            data: this.registerForm,
          }).then((res) => {
            if (res.data.code != "200") return;
            this.loading = false;
            this.$message({
              message: "注册成功",
              type: "success",
            });
            this.$router.push("/main"); // 直接使用路径
          });
        }
      });
    },
  },
};
</script>

<style  scoped>
.login {
  display: flex;
  justify-content: right;
  align-items: center;
  height: 100vh;
  background-image: url("../../../assets/door/login-background.jpg");
  background-size: cover;
}
.logo {
  padding-bottom: 10px;
  width: 95%;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  margin-right: 15%;
  border-radius: 6px;
  background: #ffffff;
  width: 370px;
  padding: 25px 25px 5px 25px;
}
::v-deep .el-input--small .el-input__inner {
  height: 38px;
  line-height: 38px;
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 38px;
}
.zczh {
  cursor: pointer;
  color: #409eff;
  font-size: 13px;
  float: right;
  margin-top: 3px;
}
::v-deep .el-input__prefix {
  font-size: 18px;
}
</style>
